"use client";

import BreadcrumbComp from "@/components/shared/BreadcrumbComp";
import { Pagination } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import { motion } from "framer-motion";
import ProjectItem from "./ProjectItem";
import Link from "next/link";
import { formatDate } from "@/utils/date";
import useFetchApi from "@/hooks/useFetchApi";

const MOCK_DATA = Array(9).fill({
  title:
    "The Arena Cam Ranh - Mô hình kết hợp nghỉ dưỡng giải trí duy nhất tại bãi dài",
  description:
    "How do you create compelling presentations that wow your colleagues and impress your managers?",
  date: "08 tháng 08, 2022",
  image:
    "https://api.mvsvn.vn/api/uploads/get_img?folder=notOauth&name=20260113193212_Rectangle%2520222.png",
});

// const ProjectItem = ({ item, type = "vertical" }) => {
//     if (type === "horizontal") {
//         return (
//             <div className="flex gap-4 group cursor-pointer">
//                 <div className="w-[180px] h-[120px] flex-shrink-0 overflow-hidden">
//                     <img
//                         src={item.image}
//                         alt={item.name}
//                         className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                     />
//                 </div>
//                 <div className="flex-1 flex flex-col justify-center">
//                     <div className="flex items-center gap-2 text-[#999] text-xs mb-2">
//                         <AiOutlineClockCircle color="#06B6D4" />
//                         <span className="text-[#06B6D4]">{item.date}</span>
//                     </div>
//                     <h3 className="text-sm font-bold text-[#333] mb-2 line-clamp-2 group-hover:text-[#E5C383] transition-colors">{item.name}</h3>
//                     <p className="text-xs text-[#666] line-clamp-2">{item.description}</p>
//                 </div>
//             </div>
//         );
//     }

//     // Vertical (Default)
//     return (
//         <div className="group cursor-pointer">
//             <div className="w-full aspect-[3/2] overflow-hidden mb-4">
//                 <img
//                     src={item.image}
//                     alt={item.name}
//                     className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                 />
//             </div>
//             <div className="flex items-center gap-2 text-[#999] text-sm mb-3">
//                 <AiOutlineClockCircle color="#06B6D4"/>
//                 <span className="text-[#06B6D4]">{item.date}</span>
//             </div>
//             <h3 className="text-lg font-bold text-[#333] mb-3 line-clamp-2 group-hover:text-[#E5C383] transition-colors">{item.name}</h3>
//             <p className="text-sm text-[#666] line-clamp-3 leading-relaxed">{item.description}</p>
//         </div>
//     );
// };

function ProjectsIndex({
  projectsPinned,
  projects: dataProjects,
  pagination: dataPagination,
}) {
  const [projects, setProjects] = useState(dataProjects || []);
  const [pagination, setPagination] = useState(dataPagination || {});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isFisrstLoad, setIsFirstLoad] = useState(true);
  const {
    data,
    errors,
    triggerFetch: loadMoreList,
  } = useFetchApi({
    url: "/projects",
    params: {
      page: page,
      isHighLight: false,
    },
    skip: true,
  });

  useEffect(() => {
    if (!isFisrstLoad) {
      setProjects(data?.data?.projects || []);
      setPagination(data?.data?.pagination || {});
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, [dataPagination]);

  useEffect(() => {
    if (!isFisrstLoad) {
      loadMoreList();
    }
  }, [page]);

  const loadMore = useCallback((p) => {
    setLoading(true);
    setPage(p);
  }, []);
  const breadcrumbs = [
    { title: "Trang Chủ", href: "/" },
    { title: "Dự Án", href: "/du-an" },
  ];

  return (
    <div className="bg-white pb-20">
      <div className="section mx-auto">
        <BreadcrumbComp items={breadcrumbs} />

        <h1 className="text-center text-4xl font-bold my-10 uppercase">
          Dự án
        </h1>

        {/* Dự án Hot Section */}
        {projectsPinned.length ? (
          <motion.div
            initial={{ y: 50, opacity: 0 }} // Trạng thái ban đầu (dưới 50px)
            whileInView={{ y: 0, opacity: 1 }} // Khi cuộn tới thì trượt lên
            viewport={{ once: true }} // Chỉ chạy 1 lần
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mb-16"
          >
            <h2 className="text-2xl font-bold mb-6 capitalize">
              Dự án nổi bật
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Left: Big Feature */}
              <Link href={`/du-an/${projectsPinned[0].id}`}>
                <div className="group cursor-pointer">
                  <div className="w-full aspect-[16/9] overflow-hidden mb-4">
                    <img
                      src={projectsPinned[0].thumbnail}
                      alt={projectsPinned[0].name}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>
                  <div className="flex items-center gap-2 text-[#999] text-sm mb-3">
                    <AiOutlineClockCircle color="#06B6D4" />
                    <span className="text-[#06B6D4]">
                      {formatDate(projectsPinned[0].createdAt)}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#333] mb-3 group-hover:text-[#007AFF] transition-colors">
                    {projectsPinned[0].name}
                  </h3>
                  <p className="text-[#666] line-clamp-3">{projectsPinned[0].description}</p>
                </div>
              </Link>
              {/* Right: List */}
              <div
                className={`flex flex-col gap-6 ${projectsPinned.slice(1).length >= 3
                  ? "max-h-[500px] overflow-y-auto pr-2"
                  : ""
                  }`}
              >
                {projectsPinned.slice(1).map((item, index) => (
                  <ProjectItem key={index} item={item} type="horizontal" />
                ))}
              </div>
            </div>
          </motion.div>
        ) : undefined}
        {/* <div className="mb-16 animate-slide-up">
                    
                </div> */}

        {/* Tin Mới Section */}
        <motion.div
          initial={{ y: 50, opacity: 0 }} // Trạng thái ban đầu (dưới 50px)
          whileInView={{ y: 0, opacity: 1 }} // Khi cuộn tới thì trượt lên
          viewport={{ once: true }} // Chỉ chạy 1 lần
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <h2 className="text-2xl font-bold mb-6 capitalize">Dự án mới</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
            {projects.map((item, index) => (
              <ProjectItem key={index} item={item} />
            ))}
          </div>

          <div className="flex justify-end">
            <Pagination
              onChange={loadMore}
              defaultCurrent={pagination.page || 1}
              total={pagination.total}
              showSizeChanger={false}
              pageSize={pagination?.perPage || 10}
            />
          </div>
        </motion.div>
        {/* <div className="animate-slide-up">
                    <h2 className="text-2xl font-bold mb-6">Tin Mới</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
                        {MOCK_DATA.map((item, index) => (
                            <NewsItem key={index} item={item} />
                        ))}
                    </div>

                    <div className="flex justify-end">
                        <Pagination defaultCurrent={1} total={100} pageSize={9} />
                    </div>
                </div> */}
      </div>
    </div>
  );
}

export default ProjectsIndex;
